/**
 * Map controls component for zoom functionality
 */

import { Component, Show } from 'solid-js';
import { MAP_Z_INDEX } from '../types/constants';
import { TooltipDelayed } from '../../tooltipDelayed/TooltipDelayed';

interface MapControlsProps {
  zoom: number;
  minZoom: number;
  maxZoom: number;
  onZoomIn(): void;
  onZoomOut(): void;
  onZoomReset?(): void;
  zoomable: boolean;
  visible: boolean;
  showReset: boolean;
}

const MapControls: Component<MapControlsProps> = (props) => {
  const canZoomIn = (): boolean => props.zoom < props.maxZoom;
  const canZoomOut = (): boolean => props.zoom > props.minZoom;
  const canZoomReset = (): boolean => props.zoom > props.minZoom;

  return (
    <Show when={props.zoomable && props.visible}>
      <div
        class="absolute bottom-0 right-0 flex flex-col bg-white border border-[#F1F1F6] shadow-[0_-2px_6px_0px_#AEAEB6] w-8 opacity-100 rounded-tl"
        style={{
          height: props.showReset ? '96px' : '64px',
          // eslint-disable-next-line @typescript-eslint/naming-convention -- CSS properties must use kebab-case for SolidJS
          'z-index': String(MAP_Z_INDEX.CONTROLS),
        }}
      >
        <TooltipDelayed text="Zoom In" position="left">
          <button
            onClick={() => {
              props.onZoomIn();
            }}
            disabled={!canZoomIn()}
            class="flex-1 flex items-center justify-center text-gray-700 hover:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed transition-colors"
            style={{ width: '30px', height: '31px' }}
          >
            <span
              class="tc-icon-zoom-in icon-font"
              aria-hidden="true"
              style={{ width: '16px', height: '16px', ['font-size']: '16px' }}
            ></span>
          </button>
        </TooltipDelayed>

        <TooltipDelayed text="Zoom Out" position="left">
          <button
            onClick={() => {
              props.onZoomOut();
            }}
            disabled={!canZoomOut()}
            class="flex-1 flex items-center justify-center text-gray-700 hover:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed transition-colors"
            style={{ width: '30px', height: '31px' }}
          >
            <span
              class="tc-icon-zoom-out icon-font"
              aria-hidden="true"
              style={{ width: '16px', height: '16px', ['font-size']: '16px' }}
            ></span>
          </button>
        </TooltipDelayed>

        <Show when={props.showReset && props.onZoomReset}>
          <TooltipDelayed text="Reset Zoom & Center" position="left">
            <button
              onClick={() => props.onZoomReset?.()}
              disabled={!canZoomReset()}
              class="flex-1 flex items-center justify-center text-gray-700 hover:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed transition-colors"
              style={{ width: '30px', height: '31px' }}
            >
              <span
                class="tc-icon-view-fit icon-font"
                aria-hidden="true"
                style={{ width: '16px', height: '16px', ['font-size']: '16px' }}
              ></span>
            </button>
          </TooltipDelayed>
        </Show>
      </div>
    </Show>
  );
};

export default MapControls;
